var h = Object.defineProperty, m = Object.defineProperties;
var I = Object.getOwnPropertyDescriptors;
var c = Object.getOwnPropertySymbols;
var S = Object.prototype.hasOwnProperty, U = Object.prototype.propertyIsEnumerable;
var p = (t, e, n) => e in t ? h(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, o = (t, e) => {
  for (var n in e || (e = {}))
    S.call(e, n) && p(t, n, e[n]);
  if (c)
    for (var n of c(e))
      U.call(e, n) && p(t, n, e[n]);
  return t;
}, l = (t, e) => m(t, I(e));
var r = [];
for (var u = 0; u < 256; ++u)
  r.push((u + 256).toString(16).slice(1));
function w(t, e = 0) {
  return (r[t[e + 0]] + r[t[e + 1]] + r[t[e + 2]] + r[t[e + 3]] + "-" + r[t[e + 4]] + r[t[e + 5]] + "-" + r[t[e + 6]] + r[t[e + 7]] + "-" + r[t[e + 8]] + r[t[e + 9]] + "-" + r[t[e + 10]] + r[t[e + 11]] + r[t[e + 12]] + r[t[e + 13]] + r[t[e + 14]] + r[t[e + 15]]).toLowerCase();
}
var d, E = new Uint8Array(16);
function x() {
  if (!d && (d = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !d))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return d(E);
}
var q = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const y = {
  randomUUID: q
};
function v(t, e, n) {
  if (y.randomUUID && !e && !t)
    return y.randomUUID();
  t = t || {};
  var s = t.random || (t.rng || x)();
  if (s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, e) {
    n = n || 0;
    for (var i = 0; i < 16; ++i)
      e[n + i] = s[i];
    return e;
  }
  return w(s);
}
function a(t, e) {
  if (!!!t)
    throw new Error(e != null ? e : "unknown assertion error");
}
class D {
  constructor(e) {
    a(e, "''getEventContentSchemaFn' is required"), this.parseEventFn = e;
  }
  validateEvent(e) {
    return this.parseEventFn(e.type, e);
  }
}
class g extends BroadcastChannel {
  /**
   *
   * Creates a new instance of `EventBus`.
   *
   * @param options - An object that allows you to customize the behavior of the `EventBus`. This object can contain the following properties:
   *      - `restrictForTab`: (default: true) A boolean that specifies whether the `EventBus` should only be used only within the current tab.
   *      - `sessionStorageKey`: (default: 'MIKRO_BUS_TAB_ID') A string that represents the key for storing the session ID in the `sessionStorage` object.
   *      - All other properties of the `EventBusOptions` interface.
   */
  constructor(e) {
    a(e.appId, "'appId' is required"), a(e.tenant, "'tenant' is required"), a(e.channel, "'channel' is required"), a(e.parseEvent, "'parseEvent' is required");
    const n = o({
      restrictForTab: !0,
      sessionStorageKey: "MIKRO_BUS_TAB_ID"
    }, e);
    if (n.restrictForTab) {
      const s = g.getSessionId(n.sessionStorageKey);
      n.channel = `${n.channel}#${s}`;
    }
    super(n.channel), this.options = o({}, n), this.validatorFactory = new D(n.parseEvent), this.onmessage = null;
  }
  /**
   * Gets the session ID for the current tab.
   *
   * @param key - A string that represents the key for storing the session ID in the `sessionStorage` object.
   * @returns A string that represents the session ID.
   */
  static getSessionId(e) {
    let n = sessionStorage.getItem(e);
    return n || (n = v(), sessionStorage.setItem(e, n)), n;
  }
  postMessage(e) {
    a(e, "'message' is required"), a(e.type && typeof e.type == "string", "'message.type' is required and must be an string");
    const n = l(o({}, e), {
      id: v(),
      appId: this.options.appId,
      tenant: this.options.tenant,
      timeStamp: Date.now()
    });
    this.validatorFactory.validateEvent(n), super.postMessage(n);
  }
}
export {
  g as MikroBus
};
